import React, { useCallback, useContext, useEffect, useState } from 'react';
import Joyride, { STATUS, ACTIONS, EVENTS } from 'react-joyride';
import { useTour } from './TourProvider';
import { getTourSteps, tourStyles } from './TourSteps';
import { UserContext } from '../../contexts/UserContext';
import { useTranslation } from 'react-i18next';

const TourComponent = ({ surveyCompleted, drawerOpen, setDrawerOpen }) => {
    const { t } = useTranslation();
    const { user } = useContext(UserContext);
    const {
        run,
        setRun,
        stepIndex,
        setStepIndex,
        completeTour,
        skipTour,
        currentTourType
    } = useTour();
    
    const [steps, setSteps] = useState([]);

    useEffect(() => {
        if (user) {
            const tourSteps = getTourSteps(user.isAdmin, surveyCompleted, t, drawerOpen, setDrawerOpen, currentTourType);
            setSteps(tourSteps);
        }
    }, [user, surveyCompleted, t, drawerOpen, setDrawerOpen, currentTourType]);

    const handleJoyrideCallback = useCallback((data) => {
        const { status, action, index, type, step } = data;

        if (step && step.beforeStep) {
            step.beforeStep();
        }

        if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
            const nextIndex = index + (action === ACTIONS.PREV ? -1 : 1);
            setStepIndex(nextIndex);
            
            const nextStep = steps[nextIndex];
            if (nextStep && nextStep.beforeStep) {
                setTimeout(() => {
                    nextStep.beforeStep();
                }, 100);
            }
        } else if ([STATUS.FINISHED].includes(status)) {
            setDrawerOpen(false);
            completeTour();
        } else if ([STATUS.SKIPPED].includes(status)) {
            setDrawerOpen(false);
            skipTour();
            setRun(false);
        }

        if (action === ACTIONS.SKIP) {
            setDrawerOpen(false);
            skipTour();
            setRun(false);
        }
    }, [setStepIndex, completeTour, skipTour, setRun, steps, setDrawerOpen]);

    if (!steps.length) return null;

    return (
        <Joyride
            continuous
            run={run}
            steps={steps}
            stepIndex={stepIndex}
            styles={tourStyles}
            callback={handleJoyrideCallback}
            showProgress={false}
            showSkipButton
            scrollToFirstStep
            scrollOffset={100}
            disableOverlayClose
            disableCloseOnEsc={false}
            locale={{
                back: t('tour.back'),
                close: t('tour.close'),
                last: t('tour.last'),
                next: t('tour.next'),
                skip: t('tour.skip'),
            }}
        />
    );
};

export default TourComponent;